import {
  textRenderer,
  nestedValueRenderer,
  jsonBoxRenderer,
  fullActionsRenderer,
} from "../components/Common/DataTable/CellRenderers";

/**
 * Table Column Configurations
 */

export const createColumns = (handlers) => {
  const { onViewConfig, onEdit, onToggle, onDelete } = handlers;

  return [
    {
      key: "action",
      label: "Action Id",
      sortable: true,
      render: textRenderer,
    },
    {
      key: "reward.fixed",
      label: "Reward",
      sortable: true,
      align: "center",
      justifyContent: "center",
      render: nestedValueRenderer("reward.fixed"),
    },
    {
      key: "reward.expiryInDays",
      label: "Expiry (In Days)",
      sortable: true,
      align: "center",
      justifyContent: "center",
      render: nestedValueRenderer("reward.expiryInDays"),
    },
    {
      key: "config",
      label: "Config",
      sortable: false,
      // align: "center",
      // justifyContent: "center",
      minWidth: "250px",
      render: jsonBoxRenderer("config", onViewConfig),
    },
    {
      key: "actions",
      label: "Action",
      align: "center",
      sortable: false,
      justifyContent: "center",
      render: fullActionsRenderer(onEdit, onToggle, onDelete),
    },
  ];
};